import React, { Ref, useMemo } from "react";
import {
  SvgIconProps,
  TextField as MuiTextField,
  TextFieldProps as MuiTextFieldProps,
} from "@mui/material";
import isArray from "lodash/isArray";
import { getIsEmptyString } from "utils/helpers";
import styles from "./TextField.styles";

export type TTextFieldProps = MuiTextFieldProps & {
  combobox?: boolean;
  multiline?: boolean;
  emptyLabel?: string;
  variant?: "outlined" | "standard" | "filled";
  iconSize?: SvgIconProps["fontSize"];
  testId?: string;
};

const TextField = React.forwardRef((props: TTextFieldProps, ref: Ref<any>) => {
  const { label, emptyLabel, testId, ...textFieldProps } = props;

  // MUI X DatePicker may pass sx to its text field slot as an array.
  const sx = [styles.textfield, ...(isArray(props.sx) ? props.sx : [props.sx])];

  const displayedLabel = useMemo(
    () =>
      textFieldProps.value || getIsEmptyString(emptyLabel) ? label : emptyLabel,
    [emptyLabel, textFieldProps.value, label],
  );

  const formHelperText = {
    variant: "standard",
    "aria-live": "polite",
    "data-qaid": testId ? `${testId}-helper-text` : undefined,
  } as const;

  return (
    <MuiTextField
      {...textFieldProps}
      label={displayedLabel}
      ref={ref}
      sx={sx}
      slotProps={{
        ...textFieldProps.slotProps,
        formHelperText,
      }}
    />
  );
});

export default TextField;
